import Covervideo from "../../../assetes/img/Covervideo.jpg";
import Registerbutton from "../../../component/Registerbutton";
import VideoFinal from "../../../assetes/video/finalllllllllll.mp4";
import { useState } from "react";
export default function PromoVideoCard() {
  const [playVideo, setPlayVideo] = useState(false);
  return (
    <div className="text-[#FFFFFF]  w-[500px] max-[600px]:w-[300px] py-14 m-auto">
      <div className="text-right p-5">
        <span className="text-[#6C6B6B] font-bold text-xl max-[600px]:text-2xl">
          ... ?! چطوری
        </span>
      </div>
      <div className="mb-20">
        <div className="relative z-10 w-[95%] flex items-center justify-center">
          {!playVideo && (
            <img
              onClick={() => {
                setPlayVideo(true);
              }}
              className="rounded-2xl border-2 cursor-pointer border-[#7E42FF]"
              src={Covervideo}
              alt="Daniibtc"
            />
          )}
          {playVideo && (
            <video
              className="rounded-2xl border-2 border-[#7E42FF]"
              src={VideoFinal}
              autoPlay
              controls
            />
          )}
        </div>

        <div className="bg-[#333333] rounded-2xl rotate-3 w-[480px] max-[600px]:w-[280px] mt-[-240px] ml-4 h-64 max-[600px]:h-[150px]  max-[600px]:mt-[-140px] absolute z-0"></div>
      </div>
      <Registerbutton />
    </div>
  );
}
